import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, get } from "@insite/mobius/utilities";
import { css } from "styled-components";


pageHeaderStyles.continueButton = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                    border: white solid 5px;
                `,
                css`
                    width: 100%;
                    border: none;
                `,
            ], "min")}
    `,
};